import axios from 'axios';
const API_ROOT_LOCAL = import.meta.env.VITE_AXIOS_API_URL_ROOT; //dev
const API_BASE_ROOT = import.meta.env.VITE_AXIOS_BASE_URL_ROOT;

export const axiosPost = async (url, data, isBase = false, page = false) => {
  try {
    const isFormData = data instanceof FormData;

    if (url === 'account_activate') {
      const config = {
        headers: {
          Accept: '*/*',
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      };
      return await axios.post(`${isBase ? API_BASE_ROOT : API_ROOT_LOCAL}/${url}`, data, config);
    } else {
      const config = {
        headers: {
          Accept: '*/*',
          ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
        },
        withCredentials: true,
      };
      return await axios.post(
        `${isBase ? API_BASE_ROOT : API_ROOT_LOCAL}/${url}${page ? '?page=' + page : ''}`,
        data,
        config,
      );
    }
  } catch (error) {
    if (error.response) {
      return {
        data: error.response.data,
      };
    }
    console.error('HTTP POST request failed', error['message']);
  }
};
